module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter01"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Phantom Scimitar")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter02"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Girl with the Violet Eyes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter03"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "space"
  }, [_vm._v("“Hassan of Aleppo”")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Oblong Box")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Occupant of the Box")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Ring of the Prophet")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("First Attempt on the Safe")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Violet Eyes Again")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Second Attempt on the Safe")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X."), _c('span', {
    staticClass: "space"
  }, [_vm._v("At the British Antiquarian Museum")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Hole in the Blind")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Hashishin Watch")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The White Beam")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("A Scream in the Night")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("A Shrivelled Hand")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Dwarf")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Woman with the Basket")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("What Came Through the Window")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX."), _c('span', {
    staticClass: "space"
  }, [_vm._v("A Rapping at Midnight")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Golden Pavilion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Black Tube")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("he Light of El-Medineh")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Three Messages")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("I Keep the Appointment")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Watcher In Bank Chambers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Strong-Room")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Slipper")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Carneta")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX."), _c('span', {
    staticClass: "space"
  }, [_vm._v("We Meet Mr. Isaacs")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX."), _c('span', {
    staticClass: "space"
  }, [_vm._v("At the Gate House")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Pool of Death")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Six Patches")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIII."), _c('span', {
    staticClass: "space"
  }, [_vm._v("How We Were Reenforced")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("My Last Meeting with Hassan of Aleppo")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0